<div class="calendar">
  <ng-container *ngIf="dateMode === 'date'">
    <div class="calendar-date">
      <div class="calendar-date__head">
        <div class="calendar-date-head">
          <button
            class="calendar-date-head__current"
            (click)="changeMode('month')">
            {{ months[activeMonth] }} {{ activeYear }}
          </button>
          <button
            class="calendar-date-head__prev"
            (click)="prevMonth()"
            [disabled]="activeYear === 1970 && activeMonth === 0">
            <ic-chevron-right-outline />
          </button>
          <button
            class="calendar-date-head__next"
            (click)="nextMonth()">
            <ic-chevron-right-outline />
          </button>
          <button
            class="calendar-date-head__close"
            (click)="close.emit()">
            <ic-close-outline />
          </button>
        </div>
      </div>
      <div class="calendar-date__week-day">
        <ng-container *ngFor="let day of days; let idx = index">
          <div class="calendar-week-day">
            <p>{{ day }}</p>
          </div>
        </ng-container>
      </div>
      <div class="calendar-date__body">
        <ng-container *ngFor="let week of calendarDate">
          <div class="calendar-date__row">
            <ng-container *ngFor="let date of week; let idxDay = index">
              <button
                class="calendar-day"
                [ngClass]="{
                  'calendar-day--first-week': idxDay === 0, 
                  'calendar-day--end-week': idxDay === 6, 
                  'calendar-day--active': (rangeStart?.getTime() ?? 0) <= date.date.getTime() && (rangeEnd?.getTime() ?? 0) >= date.date.getTime(),
                  'calendar-day--active-start': (rangeStart?.getTime() ?? 0) === date.date.getTime(),
                  'calendar-day--active-end': (rangeEnd?.getTime() ?? 0) === date.date.getTime(),
                  'calendar-day--today': date.date.getTime() === today,
                  'calendar-day--single': selectMode === 'single',
                }"
                [disabled]="date.active === 0"
                (click)="selectDate(date)">
                <ng-container *ngIf="DateTemplate">
                  <ng-container *ngTemplateOutlet="DateTemplate; context: { $implicit: date }"></ng-container>
                </ng-container>
                <ng-container *ngIf="!DateTemplate">
                  <p>{{ date.label }}</p>
                  <span
                    *ngIf="_annotations.includes(date.date.getTime())"
                    class="calendar-day__anotation"></span>
                </ng-container>
              </button>
            </ng-container>
          </div>
        </ng-container>
        <div class="calendar-date__result">
          <ng-container *ngIf="selectMode === 'single'">
            <p><strong>Terpilih:</strong> {{ (rangeStart | date : "dd MMM y") ?? "Pilih" }}</p>
          </ng-container>
          <ng-container *ngIf="selectMode === 'range'">
            <p>
              <strong>Terpilih:</strong> {{ (rangeStart | date : "dd MMM y") ?? "Dari" }} -
              {{ (rangeEnd | date : "dd MMM y") ?? "Sampai" }}
            </p>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="dateMode === 'month'">
    <div class="calendar-month">
      <div class="calendar-month__head">
        <div class="calendar-month-head">
          <button
            class="calendar-month-head__current"
            (click)="changeMode('year')">
            {{ activeYear }}
          </button>
          <button
            class="calendar-month-head__prev"
            (click)="prevYear()"
            [disabled]="activeYear === 1970">
            <ic-chevron-right-outline />
          </button>
          <button
            class="calendar-month-head__next"
            (click)="nextYear()">
            <ic-chevron-right-outline />
          </button>
          <button
            class="calendar-date-head__close"
            (click)="close.emit()">
            <ic-close-outline />
          </button>
        </div>
      </div>
    </div>
    <div class="calendar-month__body">
      <div class="calendar-month__row">
        <ng-container *ngFor="let month of months; let idxMonth = index">
          <button
            [class.active]="idxMonth === activeMonth"
            (click)="selectMonth(idxMonth)">
            {{ month }}
          </button>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="dateMode === 'year'">
    <div class="calendar-year">
      <div class="calendar-year__head">
        <div class="calendar-year-head">
          <button
            class="calendar-year-head__current"
            (click)="changeMode('month')">
            {{ yearRangeStart }} - {{ yearRangeEnd }}
          </button>
          <button
            class="calendar-year-head__prev"
            (click)="prevRangeYear()"
            [disabled]="yearRangeStart === 1970">
            <ic-chevron-right-outline />
          </button>
          <button
            class="calendar-year-head__next"
            (click)="nextRangeYear()">
            <ic-chevron-right-outline />
          </button>
          <button
            class="calendar-date-head__close"
            (click)="close.emit()">
            <ic-close-outline />
          </button>
        </div>
      </div>
      <div class="calendar-year__body">
        <div class="calendar-year__row">
          <ng-container *ngFor="let year of yearOptions; let idxYear = index">
            <button
              [class.active]="year === activeYear"
              (click)="selectYear(year)"
              [disabled]="[0, 11].includes(idxYear)">
              {{ year }}
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</div>
